import { Component, Input } from '@angular/core';
import { UiModule } from '@shared/ui/ui.module';
import { RetailMediaCampaignType } from '@rmn/models/enums/retail-media-campaign-type.enum';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'rm-retail-media-products-info',
    standalone: true,
    imports: [UiModule, CommonModule],
    templateUrl: './retail-media-products-info.component.html',
    styleUrls: ['./retail-media-products-info.component.scss']
})
export class RetailMediaProductsInfoComponent {
    @Input() public campaignType!: RetailMediaCampaignType | null;

    protected get isSelfAdvertising(): boolean {
        return this.campaignType === RetailMediaCampaignType.RETAIL_MEDIA_SELF_ADVERTISING;
    }
}
